// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Subscription_subscription__lqoSF {
  background-color: var(--color-light);
  padding: 9rem;
  width: 100%;
}
@media only screen and (max-width: 37.5em) {
  .Subscription_subscription__lqoSF {
    padding: 9rem 3rem;
  }
}
.Subscription_subscription__nav__gAJ9x {
  display: grid;
  grid-template-columns: repeat(4, max-content);
  gap: 1rem;
  border: 2px solid var(--color-grey-2);
  border-radius: 1.6rem;
  padding: 1rem;
  width: fit-content;
  font-weight: 700;
}
@media only screen and (max-width: 43.75em) {
  .Subscription_subscription__nav__gAJ9x {
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
  }
}
.Subscription_subscription__nav__active__rU79c {
  background-color: var(--color-dark);
  color: var(--color-white-2);
  border-radius: 0.5rem;
  transition: all 0.4s;
  cursor: pointer;
  padding: 1rem;
}
.Subscription_subscription__nav__inactive__BT\\+6E {
  border-radius: 0.5rem;
  transition: all 0.4s;
  color: var(--color-dark);
  cursor: pointer;
  padding: 1rem;
}
.Subscription_subscription__cardClass__4qaGk {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 40rem);
  margin-top: 3rem;
  gap: 3rem;
  justify-content: center;
}
@media only screen and (max-width: 62.5em) {
  .Subscription_subscription__cardClass__4qaGk {
    grid-template-columns: 60rem;
  }
}
@media only screen and (max-width: 43.75em) {
  .Subscription_subscription__cardClass__4qaGk {
    grid-template-columns: 42rem;
  }
}
.Subscription_subscription__cardClass_card__fatzP {
  box-sizing: border-box;
  background-color: var(--color-white);
  border: 1px solid var(--color-grey-2);
  border-radius: 1.6rem;
  padding: 4rem 2rem;
  height: fit-content;
}

.Subscription_line__LGF1W {
  content: "";
  border-bottom: 1px solid var(--color-grey-6);
  margin: 3rem 0;
}

.Subscription_beside__rH7SV {
  display: flex;
  align-items: center;
}

.Subscription_getStarted__Pvkoa {
  display: flex;
  justify-content: center;
  width: 100%;
}

.Subscription_popular__wUj3E {
  background-color: var(--color-primary);
  padding: 1rem 0.5rem;
  border-radius: 1rem;
  box-sizing: border-box;
}

.Subscription_savings__M7ApC {
  padding: 0.5rem 1rem;
  border: 1px solid var(--color-error);
  color: var(--color-error);
  font-weight: 700;
  width: fit-content;
  border-radius: 1rem;
  font-size: var(--default-font-small);
  margin: 1rem 0;
  background-color: var(--color-light-red);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Subscription.module.scss"],"names":[],"mappings":"AAEA;EACI,oCAAA;EACA,aAAA;EACA,WAAA;AADJ;AAKI;EAPJ;IAQQ,kBAAA;EAFN;AACF;AAKI;EACI,aAAA;EACA,6CAAA;EACA,SAAA;EACA,qCAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAHR;AAMQ;EAXJ;IAYQ,qCAAA;IACA,WAAA;EAHV;AACF;AAKQ;EACI,mCAAA;EACA,2BAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;AAHZ;AAMQ;EACI,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;AAJZ;AAQI;EACI,aAAA;EACA,WAAA;EACA,uCAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;AANR;AAQQ;EARJ;IASQ,4BAAA;EALV;AACF;AAMQ;EAXJ;IAYQ,4BAAA;EAHV;AACF;AAKQ;EACI,sBAAA;EACA,oCAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAHZ;;AAQA;EACI,WAAA;EACA,4CAAA;EACA,cAAA;AALJ;;AASA;EACI,aAAA;EACA,mBAAA;AANJ;;AASA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AANJ;;AASA;EACI,sCAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;AANJ;;AASA;EACI,oBAAA;EACA,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,wCAAA;AANJ","sourcesContent":["@import '../variables/breakpoints';\n\n.subscription {\n    background-color: var(--color-light);\n    padding: 9rem;  \n    width: 100%;\n\n\n\n    @media only screen and (max-width: $bp-600) {\n        padding: 9rem 3rem; \n    }\n\n\n    &__nav {\n        display: grid;\n        grid-template-columns: repeat(4, max-content);\n        gap: 1rem;\n        border: 2px solid var(--color-grey-2);\n        border-radius: 1.6rem;\n        padding: 1rem;\n        width: fit-content;\n        font-weight: 700;\n       \n\n        @media only screen and (max-width: $bp-700) {\n            grid-template-columns: repeat(2, 1fr);\n            width: 100%;\n        }\n\n        &__active {\n            background-color: var(--color-dark);\n            color: var(--color-white-2);\n            border-radius: 0.5rem;\n            transition: all 0.4s;\n            cursor: pointer;\n            padding: 1rem; \n        }\n\n        &__inactive {\n            border-radius: 0.5rem;\n            transition: all 0.4s;\n            color: var(--color-dark);\n            cursor: pointer;\n            padding: 1rem;\n        }\n    }\n\n    &__cardClass {\n        display: grid;\n        width: 100%;\n        grid-template-columns: repeat(3, 40rem);\n        margin-top: 3rem;\n        gap: 3rem;\n        justify-content: center;\n\n        @media only screen and (max-width: $bp-1000) {\n            grid-template-columns: 60rem;         \n        }\n        @media only screen and (max-width: $bp-700) {\n            grid-template-columns: 42rem;\n        }\n\n        &_card {\n            box-sizing: border-box;\n            background-color: var(--color-white);\n            border: 1px solid var(--color-grey-2);\n            border-radius: 1.6rem;\n            padding: 4rem 2rem;\n            height: fit-content;\n        }\n    }\n}\n\n.line {\n    content: '';\n    border-bottom: 1px solid var(--color-grey-6);\n    margin: 3rem 0;\n}\n\n\n.beside {\n    display: flex;\n    align-items: center;\n}\n\n.getStarted {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.popular {\n    background-color: var(--color-primary);\n    padding: 1rem 0.5rem;\n    border-radius: 1rem;\n    box-sizing: border-box; \n}\n\n.savings {\n    padding: .5rem 1rem;\n    border: 1px solid var(--color-error);\n    color: var(--color-error);\n    font-weight: 700;\n    width: fit-content;\n    border-radius: 1rem;\n    font-size: var(--default-font-small);\n    margin: 1rem 0;\n    background-color: var(--color-light-red);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subscription": `Subscription_subscription__lqoSF`,
	"subscription__nav": `Subscription_subscription__nav__gAJ9x`,
	"subscription__nav__active": `Subscription_subscription__nav__active__rU79c`,
	"subscription__nav__inactive": `Subscription_subscription__nav__inactive__BT+6E`,
	"subscription__cardClass": `Subscription_subscription__cardClass__4qaGk`,
	"subscription__cardClass_card": `Subscription_subscription__cardClass_card__fatzP`,
	"line": `Subscription_line__LGF1W`,
	"beside": `Subscription_beside__rH7SV`,
	"getStarted": `Subscription_getStarted__Pvkoa`,
	"popular": `Subscription_popular__wUj3E`,
	"savings": `Subscription_savings__M7ApC`
};
export default ___CSS_LOADER_EXPORT___;
